import { ConfigurationType } from '@server/parser';
import { ConfigurationToName } from '../types';
import { FunnelFieldLabels } from '../../../../constants/deprecated_fieldsManagementConsts';
import { getMetadataLabel } from '../../tabs/getMetadataLabel';

export const getItemType = ({
  parentType,
  dependencyType,
  saltoObjectTypes,
  _objectName,
}: {
  parentType: ConfigurationType;
  dependencyType: string;
  saltoObjectTypes: Pick<ObjectTypeName, 'objectType' | 'label'>[];
  _objectName?: string;
}) => {
  switch (parentType) {
    case ConfigurationType.fields:
      return FunnelFieldLabels[dependencyType as SweepFieldTypes] ?? dependencyType;

    case ConfigurationType.cpqData:
      return _objectName
        ? (saltoObjectTypes?.find((type) => type.objectType === _objectName)?.label ??
            _objectName) + ' Record'
        : '';

    default:
      return ConfigurationToName[parentType] ?? getMetadataLabel(parentType);
  }
};
